import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';
import React from 'react';
import { isMobile } from 'react-device-detect';
import useTier, { TierAction } from './Tier.Hooks';
import TierDelete from './sections/Tier.Delete';
import TierEdit from './sections/Tier.Edit';
import TierFilters from './sections/Tier.Filters';
import TierList from './sections/Tier.List';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

enum Actions {
  EDIT = 'edit',
  DELETE = 'delete',
}
export type Verify = Utils.VerifyExtends<Module.ProductManagement.Tier.Actions, Utils.ValueOf<typeof Actions>>;
export const tierIndexRoute = productManagementHomeRoute + '/tier/:action?/:id?';
export default function TierIndex() {
  const { lang } = getLocales();
  const tierHook = useTier();

  if (!tierHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={tierHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.tiers} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <TierFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_TIER}
                    data={{ action: TierAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={!isMobile && <TierFilters />}
            render={
              <>
                {views.edit && <TierEdit />}
                {views.delete && <TierDelete />}
                <TierList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
